import { Fragment } from "react";
import { TitleButton } from "./UI/Title";
import { HomeContent } from "./websiteContent";
import { Skills } from "./UI/ContentBlocks";
import { Box, Button, Chip, Container, Grid2 } from "@mui/material";
import Banner from "./UI/Banner";

import image from "../assets/images/velocityPrize.png";
import { ArrowForward } from "@mui/icons-material";

const Home = () => {
  return (
    <Fragment>
      <Banner />
      <section>
        <Container fixed>
          <Box className="panelBig">
            <Grid2 container spacing={2}>
              <Grid2 size={{ xs: 12, sm: 6 }}>
                <img
                  src={image}
                  alt="Velocity Prize"
                  style={{ width: "100%", height: "100%" }}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6 }} className="content">
                <span className="newSub">New · Global Skills Challenge</span>
                <h2>Introducing the Velocity Prize</h2>
                <p>
                  The{" "}
                  <a
                    href="https://education.minecraft.net/en-us/blog/introducing-the-velocity-prize"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Velocity Prize
                  </a>{" "}
                  is a new global skills challenge from Minecraft Education and
                  Microsoft that brings together computational thinking and
                  creative problem-solving, offering learners age 13-16 a chance
                  to demonstrate their ingenuity in the blocky world of
                  Minecraft.
                </p>
                <Box className="chips">
                  <Chip
                    label="Computational thinking"
                    variant="outlined"
                    size="small"
                  />
                  <Chip label="Coding" variant="outlined" size="small" />
                  <Chip
                    label="Problem-solving"
                    variant="outlined"
                    size="small"
                  />
                  <Chip label="AI" variant="outlined" size="small" />
                </Box>
                <Button
                  variant="contained"
                  color="primary"
                  href="https://education.minecraft.net/en-us/blog/introducing-the-velocity-prize"
                  target="_blank"
                  size="small"
                >
                  Go Explore <ArrowForward />
                </Button>
              </Grid2>
            </Grid2>
          </Box>
          <TitleButton
            title={HomeContent.title.title}
            buttonText={HomeContent.title.buttonText}
            paragraph={HomeContent.title.paragraph}
          />
          <div id="skillsHash">
            <Skills content={HomeContent.content} />
          </div>
        </Container>
      </section>
    </Fragment>
  );
};

export default Home;
